import { useEffect } from "react";
import { Highlighter, X } from "lucide-react";

export const HIGHLIGHT_COLOURS = { yellow: "#FFF59D", pink: "#F8BBD0", green: "#C8E6C9", blue: "#BBDEFB", orange: "#FFCC80", red: "#EF9A9A" };
export const hlStyle = (hl, key) => (hl?.[key] && HIGHLIGHT_COLOURS[hl[key]] ? { background: HIGHLIGHT_COLOURS[hl[key]] } : undefined);
export const changed = (a, b) => {
  const na = a === "" || a == null ? null : Number(a), nb = b === "" || b == null ? null : Number(b);
  if (!Number.isNaN(na) && !Number.isNaN(nb) && (na !== null || nb !== null)) return na !== nb;
  return String(a ?? "") !== String(b ?? "");
};
export const diffCls = "ring-2 ring-inset ring-[#D46117] ring-offset-0";

export function HighlightPalette({ pick, onPick, onClose }) {
  useEffect(() => {
    if (!pick) return;
    const h = (e) => { if (!e.target.closest?.("[data-hl-palette]")) onClose(); };
    const t = setTimeout(() => document.addEventListener("mousedown", h), 0);
    return () => { clearTimeout(t); document.removeEventListener("mousedown", h); };
  }, [pick, onClose]);
  if (!pick) return null;
  return (
    <div data-hl-palette data-testid="highlight-palette" className="fixed z-50 flex items-center gap-1 rounded-full border border-slate-200 bg-white p-1.5 shadow-xl" style={{ left: Math.max(8, Math.min(pick.x, window.innerWidth - 310)), top: pick.y + 48 > window.innerHeight ? Math.max(8, pick.y - 90) : pick.y + 8 }}>
      <Highlighter className="ml-1 h-3.5 w-3.5 text-[#28282E]/60" />
      {Object.entries(HIGHLIGHT_COLOURS).map(([k, c]) => (
        <button key={k} title={k} data-testid={`hl-${k}`} onClick={() => onPick(k)} className="h-6 w-6 rounded-full border border-black/10 transition hover:scale-110" style={{ background: c }} />
      ))}
      <button title="Clear highlight" data-testid="hl-clear" onClick={() => onPick(null)} className="grid h-6 w-6 place-items-center rounded-full border border-slate-300 text-[#28282E] hover:bg-slate-100"><X className="h-3.5 w-3.5" /></button>
    </div>
  );
}
